import { Schema } from "@comparaonline/products-schema";

import { useAppContext } from "../../../../../lib/appContext";
import { IDetailModalProps } from "../../../../productDetail/components/DetailModal";
import { useModalDispatcher } from "../context";

export const useProductDetailProps = (product: Schema.ProductListProduct): IDetailModalProps => {
  const {
    businessUnitConfig: { businessCode }
  } = useAppContext();
  const closeModal = useModalDispatcher();

  const productProps = {
    businessUnit: businessCode,
    divisionSlug: product.division.slug,
    productSlug: product.slug
  };

  const modalProps = {
    onClose: () => closeModal(null),
    open: true
  };

  return {
    ...productProps,
    ...modalProps
  };
};
